import { AlertCircle } from "lucide-react"
import { useTranslation } from "react-i18next"

export interface EmptyDataPanelProps {
  message?: string
}

const EmptyDataPanel = ({ message }: EmptyDataPanelProps) => {
  const { t } = useTranslation()
  return (
    <div className="flex items-start justify-center">
      <div className="flex flex-col items-center gap-2">
        <AlertCircle className="w-10 h-10" />
        <p className="mb-2">{message || t("common.message.noData")}</p>
      </div>
    </div>
  )
}

export default EmptyDataPanel
